module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAJ0lEQVRIx2NgmOSGB/3HC85pm+NBDKNGjxo9avSo0aNGjxo9FI0GAJs77BZqPSxuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/it.png
// module id = 850
// module chunks = 0